import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/Login',
            component: resolve => require(['@/page/Login.vue'], resolve),
        }, {
            path: '/',
            component: resolve => require(['@/page/index.vue'], resolve),
        },
        // 二维码管理
        {
            path: '/download',
            component: resolve => require(['@/page/home/download.vue'], resolve)
        },
        {
            path: '/map',
            component: resolve => require(['@/page/map.vue'], resolve)
        },
        {
            path: '/index',
            component: resolve => require(['@/page/index.vue'], resolve),
            redirect: '/home/systemMsg',
            children: [
                {
                    path: '/home/statistics',
                    name: '统计分析',
                    component: resolve => require(['@/page/home/statistics.vue'], resolve)
                },
                {
                    path: '/agreement/list',
                    component: resolve => require(['@/page/index/agreement/list.vue'], resolve)
                },
                {
                    path: '/about/index',
                    component: resolve => require(['@/page/index/about/index.vue'], resolve)
                },
                {
                    path: '/basic/area_list',
                    name: '区域管理',
                    component: resolve => require(['@/page/basic/area_list.vue'], resolve)
                },
                {
                    path: '/basic/area_edit',
                    component: resolve => require(['@/page/basic/area_edit.vue'], resolve)
                },
                {
                    path: '/adver/list',
                    component: resolve => require(['@/page/index/adver/index.vue'], resolve)
                },
                // 数据
                {
                    path: '/intangible/list',
                    component: resolve => require(['@/page/data/intangible/list.vue'], resolve)
                },
                {
                    path: '/intangible/edit',
                    component: resolve => require(['@/page/data/intangible/edit.vue'], resolve)
                },
                {
                    path: '/intangible/import',
                    component: resolve => require(['@/page/data/intangible/import.vue'], resolve)
                },
                {
                    path: '/intangible/import/detail',
                    component: resolve => require(['@/page/data/intangible/import_detail.vue'], resolve)
                },
                {
                    path: '/site_content/list',
                    component: resolve => require(['@/page/data/site_content_list.vue'], resolve)
                },
                {
                    path: '/site_content/edit',
                    component: resolve => require(['@/page/data/site_content_edit.vue'], resolve)
                },
                {
                    path: '/intangible/type_list', // 非遗类型-列表
                    component: resolve => require(['@/page/data/intangible/type_list.vue'], resolve)
                },
                {
                    path: '/intangible/type_add', // 非遗类型-添加
                    component: resolve => require(['@/page/data/intangible/type_add.vue'], resolve)
                },
                {
                    path: '/category/list',
                    component: resolve => require(['@/page/data/classify/list.vue'], resolve)
                },
                {
                    path: '/category/children',
                    component: resolve => require(['@/page/data/classify/children.vue'], resolve)
                },
                {
                    path: '/category/edit',
                    component: resolve => require(['@/page/data/classify/edit.vue'], resolve)
                },
                {
                    path: '/tags/list',
                    component: resolve => require(['@/page/data/tags/list.vue'], resolve)
                },
                {
                    path: '/tags/edit',
                    component: resolve => require(['@/page/data/tags/edit.vue'], resolve)
                },
                {
                    path: '/tags/classify_list',// 标签分类管理
                    component: resolve => require(['@/page/data/tags/classify_list.vue'], resolve)
                },
                {
                    path: '/tags/classify_edit',
                    component: resolve => require(['@/page/data/tags/classify_edit.vue'], resolve)
                },
                {
                    path: '/basic/area_list',
                    component: resolve => require(['@/page/basic/area_list.vue'], resolve)
                },

                // 首页
                // 轮播图 - 首页
                {
                    path: '/home/home_banner',
                    component: resolve => require(['@/page/home/home_banner.vue'], resolve)
                },
                // -添加轮播图-轮播图-首页
                {
                    path: '/home/add_banner',
                    component: resolve => require(['@/page/home/add_banner.vue'], resolve)
                },
                {
                    path: '/home/help_list',
                    name: '帮助手册',
                    component: resolve => require(['@/page/home/help_list.vue'], resolve)
                },
                {
                    path: '/home/help_add',
                    name: '帮助手册-添加和修改',
                    component: resolve => require(['@/page/home/help_add.vue'], resolve)
                },
                {
                    path: '/home/notice_list',
                    name: '公告管理',
                    component: resolve => require(['@/page/home/notice_list.vue'], resolve)
                },
                {
                    path: '/home/notice_add',
                    name: '公告管理-添加和修改',
                    component: resolve => require(['@/page/home/notice_add.vue'], resolve)
                },
                // 乐谱音频管理
                {
                    path: '/music_audio/audio',
                    component: resolve => require(['@/page/music_audio/audio.vue'], resolve)
                },
                // 添加/修改乐谱音频
                {
                    path: '/music_audio/add_audio',
                    component: resolve => require(['@/page/music_audio/add_audio.vue'], resolve)
                },
                // 乐谱分类管理
                {
                    path: '/music_audio/category',
                    component: resolve => require(['@/page/music_audio/category.vue'], resolve)
                },
                // 添加/修改乐谱分类
                {
                    path: '/music_audio/add_category',
                    component: resolve => require(['@/page/music_audio/add_category.vue'], resolve)
                },
                // 视频管理
                {
                    path: '/video_manage/video',
                    component: resolve => require(['@/page/video_manage/video.vue'], resolve)
                },
                // 照片管理
                {
                    path: '/photo_manage/photo',
                    component: resolve => require(['@/page/photo_manage/photo.vue'], resolve)
                },
                // 用户列表
                {
                    path: '/user/user',
                    component: resolve => require(['@/page/user/user.vue'], resolve)
                },
                {
                    path: '/user/detail',
                    component: resolve => require(['@/page/user/user_detail.vue'], resolve)
                },
                {
                    path: '/user/err_list',
                    component: resolve => require(['@/page/user/err_list.vue'], resolve)
                },
                {
                    path: '/user/vip_list',
                    component: resolve => require(['@/page/user/vip_list.vue'], resolve)
                },
                {
                    path: '/user/orderDetail',
                    component: resolve => require(['@/page/user/order_detail.vue'], resolve)
                },
                // 隐私协议
                {
                    path: '/home/systemMsg',
                    component: resolve => require(['@/page/home/systemMsg.vue'], resolve)
                },
                // 二维码管理
                {
                    path: '/home/qrcode_manage',
                    component: resolve => require(['@/page/home/qrcode_manage.vue'], resolve)
                },
                {
                    path: '/home/app_version',
                    name: 'APP版本管理',
                    component: resolve => require(['@/page/home/app_version.vue'], resolve)
                },
                {
                    path: '/user/errdetail',
                    component: resolve => require(['@/page/user/error_detail.vue'], resolve)
                },


                //系统
                {
                    path: '/set_up/role_list',
                    component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
                }, // 系统角色 - 系统
                {
                    path: '/set_up/add_role',
                    component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
                }, // 添加角色-系统角色 - 系统
                {
                    path: '/set_up/menu_list',
                    component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
                }, // 系统菜单 - 系统
                {
                    path: '/set_up/add_menu',
                    component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/user_list',
                    component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/addStaff',
                    component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
                }, // 添加菜单-系统菜单 - 系统
                {
                    path: '/set_up/recommend_list',
                    component: resolve => require(['@/page/set_up/recommend_list.vue'], resolve)
                }, //推荐管理
                {
                    path: '/set_up/add_recommend',
                    component: resolve => require(['@/page/set_up/add_recommend.vue'], resolve)
                }, //推荐管理添加
            ]
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js